<div *ngIf="device" class="mc-device-status-card">
  <ul class="list-unstyled">
      <li *ngIf="!!device.complianceStatus" class="cont-icon compliance-status">
          <span class="name compliance" [ngClass]="device.complianceStatus">
              <i class="fa famc hd-icon-pending"></i>
              <i class="fa famc famc-compliant"></i>
              <i class="fa famc famc-not-compliant"></i>
              <span class="align-compliance-status">{{ device.complianceStatusLocalized }}</span>
          </span>
          <!-- <ul class="list-unstyled grow" *ngIf="!device._obj.ComplianceStatus && !device.isCompliancePolicyApplicable" [ngClass]="{'show' : check}">
              <li class="compliance-list" *ngFor="complianceReason in device.complianceReasons" *ngIf="!complianceItem.ComplianceValue">
                  <span class="compliance-items">
                      <i class="fa famc famc-exclamation"></i>
                      {{ complianceReason}}
                  </span>
              </li>
          </ul> -->
          <ul class="list-unstyled grow" *ngIf="device.showCompliancePolicyMessage && device.isCompliancePolicyApplicable" [ngClass]="{'show' : check}">
              <li class="compliance-policy-messages">
                  <span class="compliance-policy-message">
                      <i class="fa famc famc-exclamation"></i>
                      {{device.compliancePolicyMessage}}
                  </span>
              </li>
          </ul>
      </li>
      <li *ngIf="!!device.daysSinceLastCheckIn" class="last-check-in">
          <div class="cont-icon">
              <span class="name">
                  <i class="fa famc famc-check-in"></i>
              </span>
              <span class="value check-in"><span>{{'label_LastCheckInTimeAgo' | xsI18n : device.daysSinceLastCheckIn}}</span></span>
          </div>
      </li>
  </ul>
</div>
